import React from "react";

const Button = ({ btnText, primary, arrow, onClick }) => {
    return (
        <div>
            <button
                // className="signup-btn"
                style={{
                    backgroundColor: primary ? "#334155" : "#F1F5F9",
                    padding: "15px 30px",
                    borderRadius: "8px",
                    fontSize: "16px",
                    fontWeight: "600",
                    fontFamily: "Metropolis",
                    color: primary ? "#FFFFFF" : "",
                    border: "none", cursor: 'pointer'

                }}
                onClick={onClick}
            >
                {btnText}
                {arrow && <img src="/img/button/arrow.png" style={{ marginLeft: "10px" }} width={22} height={22} />}

            </button>
        </div >
    );
};

export default Button;
